<template>
    <!--<div class="majorBox" v-show="majorShow">-->
        <div class="index-nav">

            <div class="major">
                <P @click="contrary" class="chooseMajor"><span v-text="major.name"></span><span :class="{ reversal: majorShow }" class="iconfont icon-iconfontarrows1"></span></P>
                <div class="majorBox" v-show="majorShow">
                <ul>
                    <li v-for="(item,i) in data" :key="i" @click.stop="majorClick(item.name,item.id)" ref="major_li" :ID="item.id" >
                        <span v-text="item.name"></span>
                    </li>
                </ul>
                </div>
            </div>

            <div  v-if="myvideoHeader">
                <div class="user" v-if="loginbool">
                    <span class="iconfont icon-user" @click="UserShow"></span>
                    <ul v-show="userShow">
                        <div class="jiao"></div>
                        <li><router-link to="/myvideo">我的课程</router-link></li>
                        <li><router-link to="/myOrder">我的订单</router-link></li>
                        <li><router-link to="/myAddr">我的地址</router-link></li>
                        <li><router-link to="/myRedpacket">我的红包</router-link></li>
                        <li @click="logout">退出登录</li>
                    </ul>
                </div>
                <div v-if="!loginbool" class="users">
                    <router-link :to="{name:'login'}">登录 / </router-link>
                    <router-link :to="{name:'register'}">注册</router-link>
                </div>
            </div>
        </div>
    <!--</div>-->
</template>

<script>
    import axios from "axios";
    import qs from "qs";
var logout = function () {
    axios
        .post(
            "/wap/user/logout "
        )
        .then(data => {
            console.log(data);
            this.majorShow = false;
            localStorage.removeItem("logined");
            // localStorage.removeItem("userName");
            //localStorage.removeItem("passWord");
            this.userShow = false;
            this.loginbool = false;
        })
        ["catch"](error => {
            console.log(error);
        });
};
var UserShow = function () {
  this.userShow = !this.userShow;
  this.majorShow = false;
};
var majorClick = function (name, id) {
  this.CurrentId = id;
  this.major.name = name;
  this.major.id = id;
  var _this = this;
  // this.majorShow = false;
  localStorage.setItem("categoryId", id);
  localStorage.setItem("category", name);
  this.$emit("major-change", id, name);
  // alert(123);
  // ev.preventDefault();
  // return false
  setTimeout(function () {
    _this.majorShow = false;
  }, 10);
};
var contrary = function () {
  this.majorShow = !this.majorShow;
  this.userShow = false;
};
//判断是否登录
    var ifLogin = function () {
        axios
            .post(
                "/wap/userHandle/getUserInfo",
            )
            .then(data => {
                var data = data.data.data;
                if(data === 'notLogin'){
                   this.loginbool = false;
                }else{
                    this.loginbool = true;
                };
            })
            ["catch"](error => {
            console.log(error);
        });
    }

export default {
  name: "majorChoice",
  created() {
    this.ifLogin();
    this.data = this.data || JSON.parse(localStorage.getItem("categoryArr"));
    let data = this.data;
    if (!localStorage.getItem("categoryArr")) {
      localStorage.setItem("categoryArr", "asdas");
      localStorage.setItem("categoryId", data[0].id);
      localStorage.setItem("category", data[0].name);
    }
    this.major.name = localStorage.getItem("category") || data[0].name;
    this.major.id = localStorage.getItem("categoryId") || data[0].id;
    this.major.majorArr = localStorage.getItem("categoryArr") || data;
    this.CurrentId = this.major.id;

    // console.log(localStorage.getItem("logined"));
    // console.log(localStorage.getItem("userName"));
    //   console.log(localStorage.getItem("passWord"));
    //   console.log(localStorage.getItem("logined") &&
    //       localStorage.getItem("logined") === "true");
  },
  computed: {},
  data() {
    return {
      CurrentId:-1,
      major: {},
      majorArr: [],
      majorShow: false,
      userShow: false,
      // loginbool: () => {
      //   return (
      //     localStorage.getItem("logined") &&
      //     localStorage.getItem("logined") === "true"
      //   );
      // }
        loginbool:'false'
    };
  },
  watch:{
    //属性检测，渲染样式修改
    CurrentId(newVal,oldVal){
      if(newVal != oldVal){

          let oldIndex = this.$refs.major_li.findIndex((item)=>{    //查找当前章的索引
            return item.id == oldVal;
          });
          if(oldIndex != "-1"){
            this.$refs.major_li[oldIndex].style.color = '#000';
          }

          let index = this.$refs.major_li.findIndex((item)=>{    //查找当前章的索引
              return item.id == newVal;
          });
          if(index != "-1"){
            this.$refs.major_li[index].style.color = '#ff8005';
          }
      }
    }
  },
  methods: {
    contrary,
    UserShow,
    logout,
    majorClick,
      ifLogin
  },
  props: {
    data: {
      type: Array
    },
    myvideoHeader: {
      default: true
    }
  }
};
</script>

<style scoped lang="scss">
.majorBox{
    position: fixed;
    top: 90px;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.8);
    /*z-index: 2;*/
    overflow-y:scroll;
    overflow-y: -webkit-paged-y;
    ul{
      height: 90%;
      overflow-y: scroll;
    }
}
.chooseMajor {
  display: inline-block;
  margin: 0 auto;
}
.index-nav {
  height: 90px;
  text-align: center;
  // position: relative;
  background: #fff;
  z-index: 5;
  width: 100%;
  position: fixed;
  .users {
    position: absolute;
    right: 30px;
    top: 0;
    height: 100%;
    width: auto;
    text-align: right;
    font-size: 28px;
    color: #999;
    line-height: 90px;
    a {
      width: 100%;
      height: 100%;
    }
  }
  .user {
    position: absolute;
    right: 30px;
    top: 0;
    height: 100%;
    width: 80px;
    text-align: right;
    .iconfont {
      line-height: 90px;
      display: block;
      font-size: 30px;
      width: 100%;
      background: linear-gradient(to right bottom, #ff880c, #ffcc58);
      -webkit-background-clip: text;
      color: transparent;
    }
    ul {
      width: 245px;
      background: #f7f7fd;
      position: absolute;
      right: -10px;
      top: 110px;
      .jiao {
        height: 0;
        width: 0;
        position: absolute;
        top: -20px;
        right: 15px;
        border: 10px solid transparent;
        border-bottom-color: #f7f7fd;
      }
      &:last-child {
        border-bottom: none;
      }
      li {
        &:last-child {
          border-bottom: none;
        }
        text-align: center;
        width: 100%;
        font-size: 30px;
        border-bottom: 1PX solid #e1e1e1;
        line-height: 90px;
        color: #333333;
        a {
          width: 100%;
          height: 100%;
          display: block;
          color: #333333;
        }
      }
    }
  }
  .major {
    width: 100%;
    height: 100%;
    text-align: center;
    color: #333;
    line-height: 90px;
    font-size: 30px;
    p {
      .iconfont {
        margin-left: 15px;
        font-size: 30px;
        line-height: 90px;
        display: inline-block;
      }
    }
    ul {
      /*border-top: 1PX solid #e1e1e1;*/
      position: relative;
      width: 100%;
      /*top: -5px;*/
      li {
        border-top: 1PX solid #e1e1e1;
        background: #fff;
      }
    }
  }
}
</style>
